var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrand2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-14.97 -24.95 129.74 149.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0096d6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8 49.9C99.8 22.34 77.46 0 49.9 0c-.7514 0-1.499.019-2.243.0531L37.4502 28.1066h8.89c5.2886 0 8.1387 4.0721 6.3284 9.0456l-12.5902 34.6-10.5713-.0019 13.5106-37.0858h-7.9489L21.5581 71.7503h-10.575l15.8863-43.6437h.0019l9.556-26.264C15.4139 7.721 0 27.0097 0 49.9c0 23.5695 16.3436 43.3212 38.3154 48.5451l9.2601-25.448h.0076l16.336-44.8905H83.39c5.2942 0 8.1425 4.0721 6.3322 9.0456L78.6593 67.5416c-.8425 2.315-3.5465 4.2087-6.0095 4.2087H58.6155L48.418 99.7773c.4915.0132.9867.0227 1.482.0227 27.56 0 49.9-22.3418 49.9-49.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0939 34.638h-7.945L61.0214 65.1677h7.9451L80.094 34.638"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand2);
export default __webpack_public_path__ + "static/media/brand2.ef32c134471d885d981da0263845d52c.svg";
export { ForwardRef as ReactComponent };